

const contentful = require('contentful-management');
const config = require('../../../config/config');

let cachedSpace = null;

module.exports = () => {
  if (!cachedSpace) {
    const accessToken = localStorage.getItem('contentfulToken');

    if (!accessToken) {
      return Promise.reject(Error('Missing contentfulToken'));
    }

    const spaceId = config.contentful.spaceId;
    const environment = config.contentful.environment || 'master';

    const client = contentful.createClient({
      accessToken: accessToken
    });

    cachedSpace = client.getSpace(
      spaceId
    ).then((space) => space.getEnvironment(environment));
  }

  return cachedSpace;
};
